export const SET_PROFILE = "setProfile";
export const PROFILE_RESET_STATE = "profileResetState";
export const SET_CEP = "setCep";
// export const SET_DAYS_OFF = 'setDaysOff';
// export const PROFILE_REMOVE_WEEKDAY = 'profileRemoveWeekDay';
// export const PROFILE_ADD_WEEKDAY = 'profileAddWeekDay';
 export const SET_LOGO = 'setLogo';
